import './style.scss';
import Images from 'assets/Images';

export default function SideHelpIcon(props) {
    const { infoContent } = props;
    return <div className='side-help-icon__helpContainer'>
        <div className='side-help-icon__help'>
            <img src={Images.help} />
        </div>
        <div className='side-help-icon__helpContent'>{infoContent}</div>
    </div>
}